import { useXGScale } from '@statsbomb/kitbag-datavis';
import { useAtomValue } from 'jotai';
import { useTheme } from 'styled-components';
import { pitchMarkerColouringModeAtom } from '@/atoms/visualisation';
import { BLOCKED_OUTCOME, GOAL_OUTCOME, OWN_GOAL_TYPE, SAVED_SHOT_OUTCOMES } from '@/consts/visualisations';
import { ShotMapEventMarker } from '@/types/visualisation';
import { isNullish } from '@/utils/predicates';
import { useObvScale } from '../useObvScale';

export const useShotMarkerColours = () => {
  const { dataObjects } = useTheme().colours.visualisations;
  const getXgColor = useXGScale();
  const getObvColor = useObvScale();
  const colouringMode = useAtomValue(pitchMarkerColouringModeAtom);

  const getMetricColour = ({ obv, xg }: ShotMapEventMarker) => {
    if (colouringMode === 'obv') return isNullish(obv) ? dataObjects.neutral.main : getObvColor(obv);
    return getXgColor(xg ?? 0);
  };

  const getShotMarkerFill = (event: ShotMapEventMarker) => {
    if (event.type === OWN_GOAL_TYPE) return dataObjects.inverse;
    if (event.outcome === BLOCKED_OUTCOME) return dataObjects.neutral.main;
    return getMetricColour(event);
  };

  const getShotMarkerStroke = (event: ShotMapEventMarker) => {
    if (
      event.type === OWN_GOAL_TYPE ||
      event.outcome === GOAL_OUTCOME ||
      (!!event.outcome && SAVED_SHOT_OUTCOMES.includes(event.outcome))
    ) {
      return dataObjects.inverse;
    }
    return getMetricColour(event);
  };

  return { getShotMarkerFill, getShotMarkerStroke };
};
